import { render } from "./TheFooter.vue?vue&type=template&id=7decaff6"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=7decaff6&lang=css"
script.render = render

export default script